import { Dispatch } from 'react';
import { WalletCreditListParam, WalletCreditListRes } from '../types/credit-type';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { formatDay, getError } from '../comm';
import { preFillZero } from 'src/app/common/utils';

const CREDIT_BASE_URL = `${ADMIN_URL}/pruwallet/admin/credits`;

export const getWalletCreditList = async (
  params: WalletCreditListParam,
  dispatch?: Dispatch<any>,
): Promise<WalletCreditListRes> => {
  const path = `${CREDIT_BASE_URL}/history`;
  const apiParams = {
    ...params,
    agentCode: params.agentCode ? preFillZero(params.agentCode) : undefined,
    transactionDateFrom: formatDay(params.transactionDateFrom),
    transactionDateTo: formatDay(params.transactionDateTo),
    expiryDateFrom: formatDay(params.expiryDateFrom),
    expiryDateTo: formatDay(params.expiryDateTo),
  };
  return apiClient
    .get<WalletCreditListRes>(path, { params: apiParams })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};
